import React, { useEffect, useMemo } from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiArrowLeft, FiExternalLink } from "react-icons/fi";
import { Link as RouterLink, useParams } from "react-router-dom";
import { ROUTE_PATHS } from "../config/routes";

export const PaymentAppReturnPage: React.FC = () => {
  const { requestId = "" } = useParams<{ requestId: string }>();
  const normalizedRequestId = normalizeRequestId(requestId);
  const appReturnUrl = normalizedRequestId
    ? `omidib://payment-result/${encodeURIComponent(normalizedRequestId)}`
    : "";
  const webResultUrl = normalizedRequestId
    ? `${ROUTE_PATHS.PAYMENT_RESULT.replace(":requestId", encodeURIComponent(normalizedRequestId))}`
    : ROUTE_PATHS.HOME;
  const isMobileBrowser = useMemo(
    () =>
      typeof navigator !== "undefined" &&
      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent),
    [],
  );

  const pageBg = useColorModeValue("light.900", "dark.900");
  const panelBg = useColorModeValue("white", "dark.50");
  const borderColor = useColorModeValue("blackAlpha.100", "whiteAlpha.200");

  useEffect(() => {
    if (!normalizedRequestId) return;

    const redirectTimer = window.setTimeout(() => {
      if (isMobileBrowser) {
        window.location.assign(appReturnUrl);
      } else {
        window.location.replace(webResultUrl);
      }
    }, 180);

    return () => window.clearTimeout(redirectTimer);
  }, [appReturnUrl, isMobileBrowser, normalizedRequestId, webResultUrl]);

  return (
    <Box minH="100vh" bg={pageBg} py={{ base: 8, md: 12 }} px={4} dir="rtl">
      <Container maxW="560px">
        <Box
          bg={panelBg}
          border="1px solid"
          borderColor={borderColor}
          borderRadius="3xl"
          p={{ base: 6, md: 8 }}
          textAlign="center"
        >
          <VStack spacing={5}>
            <Icon as={FiExternalLink as any} boxSize={12} color="brand.500" />
            <Heading size="md">بازگشت از درگاه پرداخت</Heading>
            <Text color="gray.500">
              در حال باز کردن اپلیکیشن امید برای نمایش نتیجه پرداخت هستیم.
            </Text>
            {appReturnUrl && (
              <Button
                as="a"
                href={appReturnUrl}
                colorScheme="brand"
                borderRadius="full"
                leftIcon={<Icon as={FiArrowLeft as any} />}
                width="full"
              >
                بازگشت به اپلیکیشن
              </Button>
            )}
            <Button
              as={RouterLink}
              to={webResultUrl}
              variant="outline"
              borderRadius="full"
              width="full"
            >
              مشاهده نتیجه در وب
            </Button>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

const normalizeRequestId = (value?: string) =>
  String(value || "")
    .trim()
    .slice(0, 64);
